import styled from 'styled-components';
import { mdBold } from '../theme/typography';
import { themeColor } from '../theme/colors';
import { ScrollArea } from '@mantine/core';

const BaseContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  border-radius: 12px;

  --padding: 24px;
  padding: var(--padding);

  border: 1px solid ${themeColor('strokeSecondary')};
`;

const Scrollable = styled(ScrollArea)`
  & .mantine-ScrollArea-viewport {
    padding: var(--padding);
    --padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  border-radius: 12px;
  border: 1px solid ${themeColor('strokeSecondary')};
`;

// Outlined Container
export const Outlined = styled(BaseContainer)`
  background: ${themeColor({
    dark: 'backgroundDark',
    light: 'backgroundLight',
  })};
`;

// Solid Container
export const Solid = styled(BaseContainer)`
  background: ${themeColor('backgroundLight')};
`;

// Filled
export const Filled = styled(Solid)`
  border: none;
`;

export const ScrollableOutlined = styled(Scrollable)`
  background: ${themeColor({
    dark: 'backgroundDark',
    light: 'backgroundLight',
  })};
`;

export const ScrollableSolid = styled(Scrollable)`
  background: ${themeColor('backgroundLight')};
`;

export const ScrollableFilled = styled(ScrollableSolid)`
  border: none;
`;

export const Top = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.h3`
  display: flex;
  align-items: center;
  gap: 10px;

  ${mdBold}
  color: ${themeColor('textPrimary')};
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;

  & svg {
    color: ${themeColor('textTertiary')};
  }
`;

export const TopRightSection = styled.div<{ addRightMargin: boolean }>`
  ${mdBold};
  margin-right: ${({ addRightMargin }) => (addRightMargin ? 'var(--space-300)' : '0px')};
  color: ${themeColor('textTertiary')};
  margin-top: 0;
  margin-bottom: 0;
  margin-left: auto;

  font-size: 14px;
  line-height: 1.4;
`;
